module.exports = __webpack_public_path__ + "static/media/bubble-2.2831fd02.png";